// 视宣号企业版定制版音频合成相关接口
import requestForComplex from "@/utils/requestForComplex";
import request from "@/utils/request";

// 合成模板-行业列表
export function industryList(params) {
  return requestForComplex({
    url: "/musicringuser/industryList",
    method: "post",
    params: params
  });
}

// 铃音合成
export function saveMusic(params) {
  return requestForComplex({
    url: "/musicringdetail/saveMusic",
    method: "post",
    params: params
  });
}

// 配音列表（主播选择）
export function findDubinList(params) {
  return requestForComplex({
    url: "/videoringIndustry/findDubinList",
    method: "post",
    params: params
  });
}

// 背景音乐（背景音乐选择）
export function findBackList(params) {
  return requestForComplex({
    url: "/videoringIndustry/findBackList",
    method: "post",
    params: params
  });
}

// 自定义试听
export function saveMusicHasBack(params) {
  return requestForComplex({
    url: "/musicringdetail/saveMusicHasBack",
    method: "post",
    params: params
  });
}

// 行业分类列表
export function findIndustry(params) {
  return requestForComplex({
    url: "/videoringIndustry/findIndustry",
    method: "post",
    params: params
  });
}

// 各分类列表
export function findWordList(params) {
  return requestForComplex({
    url: "/videoringIndustry/findWordList",
    method: "post",
    params: params
  });
}

// 创建咪咕集团
export function createMiguCircle(params) {
  return request({
    url: "/orderSelf/noToken/createMiguCircle",
    method: "post",
    params: params,
    metaValue: "创建咪咕集团"
  });
}

// 修改咪咕集团状态（阳光计划弹窗完成后调用）
export function editMiguCircleService(params) {
  return request({
    url: "/orderSelf/noToken/editMiguCircleService",
    method: "post",
    params: params,
    metaValue: "修改咪咕集团状态"
  });
}



// WEBPACK FOOTER //
// ./src/api/api/complex.js